import { render, staticRenderFns } from "./allowances.vue?vue&type=template&id=022c66ac&"
import script from "./allowances.vue?vue&type=script&lang=js&"
export * from "./allowances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports